import * as React from 'react';
import { ArticleParagraph3 } from '@cian/ui-kit/typography';
import { INFRASTRUCTURE_MAP_ICON_MAP } from '../../../../constants/infrastructure';
import * as styles from './styles.css';

export interface IMapBalloonProps {
  title: string;
  description: string;
  type: string;
}

export function MapBalloon({ title, description, type }: IMapBalloonProps) {
  const Icon = INFRASTRUCTURE_MAP_ICON_MAP.get(type);

  if (!Icon) {
    return null;
  }

  return (
    <div className={styles['balloon']}>
      <div className={styles['icon']}>
        <Icon color={'white_100'} />
      </div>
      <div>
        <ArticleParagraph3>{title}</ArticleParagraph3>
        <ArticleParagraph3 color={'gray60_100'}>{description} мин. пешком</ArticleParagraph3>
      </div>
    </div>
  );
}
